'use strict';

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _signupOrLoginButton = require('./signup-or-login-button');

var _signupOrLoginButton2 = _interopRequireDefault(_signupOrLoginButton);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

module.exports = _react2['default'].createClass({
    displayName: 'SEO Title Section',

    propTypes: {
        title: _react2['default'].PropTypes.string.isRequired,
        subtitle: _react2['default'].PropTypes.string.isRequired,
        buttonText: _react2['default'].PropTypes.string.isRequired
    },

    render: function render() {
        var props = this.props;
        var signupOrLoginButtonProps = {
            buttonText: props.signupButtonText
        };
        return _react2['default'].createElement(
            'div',
            null,
            _react2['default'].createElement(
                'div',
                { className: 'm-marketing-page--title-section row text-center l-padding-t-60 l-padding-b-10' },
                _react2['default'].createElement(
                    'div',
                    { className: 'columns small-12' },
                    _react2['default'].createElement(
                        'h1',
                        { className: 'm-marketing-page--title' },
                        props.title
                    ),
                    _react2['default'].createElement(
                        'h4',
                        { className: 'm-marketing-page--subtitle downsize' },
                        props.subtitle
                    )
                )
            ),
            _react2['default'].createElement(_signupOrLoginButton2['default'], _extends({}, signupOrLoginButtonProps, props))
        );
    }
});


/*****************
 ** WEBPACK FOOTER
 ** ./src/landing-pages/components/common/title-section.jsx
 ** module id = 1209
 ** module chunks = 0
 **/